export default __webpack_public_path__ + "static/media/BlogIndexPage.0f03fbdc.jpeg";